const l0 = () => import("/src/routes/layout.tsx");

const p0 = () => import("/src/routes/index.page.tsx");

export default [
  [/^\/?$/, [p0, l0], [], ],
]